import { displayCoefValue } from '../../../../helpers';
import type { NumberFormatterFactoriesMap } from './types';
import { buildCurrencyFormatOptions } from './utils/buildCurrencyFormatOptions';
import { normalizePercentValue } from './utils/normalizePercentValue';

const numberFormatterFactories: NumberFormatterFactoriesMap = {
    number: (
        locale,
        { minimumFractionDigits, maximumFractionDigits }
    ) => new Intl.NumberFormat(locale, {
        minimumFractionDigits: minimumFractionDigits ?? 0,
        maximumFractionDigits: maximumFractionDigits ?? 2,
        style: 'decimal',
        roundingMode: 'halfCeil',
    }),

    currency: (
        locale,
        setting
    ) => new Intl.NumberFormat(
        locale,
        buildCurrencyFormatOptions(setting, 2, 2),
    ),

    currencyInt: (
        locale,
        setting
    ) => new Intl.NumberFormat(
        locale,
        buildCurrencyFormatOptions(setting, 0, 0),
    ),

    percent: (
        locale,
        { minimumFractionDigits, maximumFractionDigits }
    ) => {
        const formatter = new Intl.NumberFormat(locale, {
            minimumFractionDigits: minimumFractionDigits ?? 0,
            maximumFractionDigits: maximumFractionDigits ?? 0,
            style: 'percent',
            roundingMode: 'trunc',
        });

        return {
            format: (value: number) => {
                return formatter.format(normalizePercentValue(value));
            },
        };
    },

    bonus: (
        locale,
        setting
    ) => new Intl.NumberFormat(
        locale,
        buildCurrencyFormatOptions({ ...setting, currency: 'Bonuses' }, 0, 0),
    ),

    // формат собственной реализации: Intl тут не участвует,
    // поэтому formatToParts не поддерживается
    coef: (_, { oddsType }) => ({
        format: (value: number) => {
            return displayCoefValue(value, oddsType);
        }
    })
};

export {
    numberFormatterFactories,
}
